import { BaseWidgetFormFields } from 'components/consumer-page-widgets/BaseWidgetFormFields';
import { Button, Typography } from 'ui';
import { Form, Formik } from 'formik';
import {
  MetroAreaContainerWidgetFields,
  MetroAreaContainerWidgetFormFields,
} from 'components/consumer-page-widgets/metro-area-container-widget/MetroAreaContainerWidgetFormFields';
import { StoreType } from 'utils/connect';
import { Widgets } from '@tock/shared/types/widget';
import { consumer } from '@tock/coretypes';
import { fetchAll as fetchAllMetroAreas } from 'actions/MetroAreaActions';
import { fetchAllNamedConfigurations } from 'actions/ConsumerPageActions';
import {
  getBaseFormFieldsInitialValues,
  useCreateNamedConfigurations,
} from 'components/consumer-page-widgets/widgetFormUtils';
import { useAppDispatch } from 'state/hooks';
import { useSelector } from 'react-redux';
import {
  widgetFormButtonContainer,
  widgetFormRoot,
} from 'components/consumer-page-widgets/widgetFormCssDefs';
import React, { FunctionComponent } from 'react';

interface CreateMetroAreaContainerFormProps {
  onCompleteOrCancel(): void;
}

export const CreateMetroAreaContainerForm: FunctionComponent<
  React.PropsWithChildren<CreateMetroAreaContainerFormProps>
> = ({ onCompleteOrCancel }) => {
  const createNamedConfig = useCreateNamedConfigurations();

  const dispatch = useAppDispatch();

  React.useEffect(() => {
    dispatch(fetchAllNamedConfigurations());
    dispatch(fetchAllMetroAreas());
  }, [dispatch]);

  const activeNamedConfigs = useSelector(
    (state: StoreType) => state.consumerPage.namedConfigurations
  ) as consumer.NamedConfiguration[]; // TODO: Fix types on consumerPage state slice

  const marketingWidgets = activeNamedConfigs.filter((config) => {
    return config.widgetType === 'widget-creator-widget';
  });

  const metroAreas = useSelector(
    (state: StoreType) => state.metroArea.metroAreaList
  ) as consumer.MetroArea[];

  const handleSubmit = ({
    name,
    defaultWidgetNamedConfigurationId,
    widgets,
  }: MetroAreaContainerWidgetFields) => {
    return createNamedConfig({
      name,
      widgetType: Widgets.WidgetCreatorWidgetType,
      metroAreaWidgetConfig: {
        defaultWidgetNamedConfigurationId,
        metroWidgets: widgets,
      },
    }).then(onCompleteOrCancel);
  };

  return (
    <>
      <Typography variant="heading1Bold">Create widget</Typography>
      <Formik<MetroAreaContainerWidgetFields>
        enableReinitialize
        initialValues={{
          ...getBaseFormFieldsInitialValues(),
          widgets: [],
        }}
        onSubmit={handleSubmit}
      >
        {({ setFieldValue }) => (
          <Form css={widgetFormRoot}>
            <BaseWidgetFormFields />
            <MetroAreaContainerWidgetFormFields
              marketingWidgets={marketingWidgets}
              metroAreas={metroAreas}
              setFieldValue={setFieldValue}
            />
            <div css={widgetFormButtonContainer}>
              <Button type="submit">Submit</Button>
              <Button variant="outlined" type="button" onClick={onCompleteOrCancel}>
                Cancel
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};
